import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "../../../../shareModule/services/auth-service.service";
import { LocalServiceService } from "../../../../shareModule/services/local-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import moment from 'moment';
import { Clipboard } from "@angular/cdk/clipboard";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: 'app-giveaway-survey',
    templateUrl: './giveaway-survey.component.html',
    styleUrls: ['./giveaway-survey.component.scss']
})

export class GiveawaySurveyComponent implements OnInit {
    @Input() giveaway: any | null = {}

    constructor(
        private router: Router,
        private local: LocalServiceService,
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private clipboard: Clipboard,
        private spinner: NgxSpinnerService,
        private formBuilder: FormBuilder) { }

    currentPage: number = 0;
    surveyQuestions = [];
    survey: any = {
        giveawaySurveyQuestions: []
    }
    surveyInput: any = []
    appUserId = 0
    isLogin = 0

    ngOnInit(): void {

        const getUser = this.local.getUser();

        if (getUser) {
            this.appUserId = getUser.id;
        }

        (getUser) ? this.isLogin = 1 : 0;
        this.initSurvey()
    }



    initSurvey() {
        this.auth.giveaway_survey_fetch(this.giveaway.id).subscribe((resp: any) => {
            this.survey = resp.body
            if (this.survey == null) {
                this.toastr.warning("Survey Not Found")
                this.giveaway.showSurvey = false
            } else {
                this.survey.giveawaySurveyQuestions.map((row: any) => {
                    row.answer = JSON.parse(row.answer)
                    row.selectedOption = null

                    const checkUser = row.giveawaySurveyParticipants.filter((val: any) => val.userId == this.appUserId)
                    if (checkUser.length > 0) {
                        this.giveaway.hasSurvey = true
                        row.selectedOption = checkUser[0].answer
                    }
                })
                this.surveyQuestions = this.survey.giveawaySurveyQuestions
            }
        })
    }



    nextPage() {
        if (this.currentPage < this.surveyQuestions.length - 1) {
            this.currentPage++;
        }
    }

    previousPage() {
        if (this.currentPage > 0) {
            this.currentPage--;
        }
    }

    submitSurvey() {
        if (this.isLogin == 0) {
            return this.toastr.error("Please Login First !")
        }

        const validation = this.surveyQuestions.filter((row: any) => row.selectedOption == null)
        if (validation.length > 0) {
            return this.toastr.warning("Please answer all Questions !")
        }
        const formData = []
        this.surveyQuestions.map((row: any) => {
            formData.push({
                userId: this.appUserId,
                surveyId: this.survey.id,
                questionId: row.id,
                answer: row.selectedOption
            })
        })

        this.auth.giveaway_survey_participate({ answer: formData }).subscribe((response: any) => {
            this.toastr.success("Successfully Sent Survey")
            this.giveaway.showSurvey = false
            this.giveaway.hasSurvey = true
        })

        // Handle the survey submission here
    }


}